export default "__VITE_ASSET__CK1k5$VM__"